export const UserActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  LOGOUT_USER: 'LOGOUT_USER'
}